import React from 'react';
import { IEntityConfig } from './entity-manager.types';
import { UniversalEntitySearchInput } from '../universal-claims-search-input';

interface IEntitySearchInputProps<T> {
    entityConfig: IEntityConfig<T>;
    onEntitySelected: (entityId: string) => Promise<void>;
    onBulkEntitiesSelected?: (entityIds: string[]) => Promise<void>;
    disabled?: boolean;
}

/**
 * Generic entity search input component that wraps UniversalEntitySearchInput
 */
export function EntitySearchInput<T>(props: IEntitySearchInputProps<T>): React.ReactElement {
    const { entityConfig, onEntitySelected, onBulkEntitiesSelected, disabled } = props;

    return (
        <UniversalEntitySearchInput<T>
            entityConfig={entityConfig}
            disabled={disabled}
            onEntitySelected={onEntitySelected}
            onBulkEntitiesSelected={onBulkEntitiesSelected}
        />
    );
}
